import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, forkJoin } from 'rxjs';
import { map } from 'rxjs/operators';

import { Config } from '../config';
import { CommonService } from './common.service';

@Injectable({ providedIn: 'root' })
export class GuideAndBucketContentService {
  matchExtensionToMimetype = {
    doc: 'application/msword',
    docx: 'application/msword',
    dotx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    xls: 'application/vnd.ms-excel',
    xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    pptx: 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
    pdf: 'application/pdf',
    jpg: 'image/jpeg',
    jpeg: 'image/jpeg',
    png: 'image/png',
    gif: 'image/gif',
    mp4: 'video/mp4',
  };

  currentFaqEndpointName: string;

  constructor(private http: HttpClient, private cService: CommonService) {}

  private getTrainingModuleMeta(moduleName: string) {
    return this.http
      .get(`${Config.apiRoot.uri}faq/${moduleName}/meta`, {
        headers: { vrmCustom_requestName: 'Training Module' },
      })
      .pipe(
        map((response) => {
          console.log('Training module meta - API', response);
          return response;
        })
      );
  }

  private getAllTrainingModules(moduleName: string): Observable<any> {
    return this.http
      .get(`${Config.apiRoot.uri}faq/${moduleName}`, {
        headers: { vrmCustom_requestName: 'Training Module' },
      })
      .pipe(
        map((response) => {
          console.log('All Training Module', response);
          return response;
        })
      );
  }

  getDocument(requestPath: string): Observable<any> {
    const refinedPath = requestPath.startsWith(`/`) ? requestPath.replace(/\//, '') : requestPath;

    return this.http.get(`${Config.apiRoot.uri}${refinedPath}`, {
      headers: { vrmCustom_requestName: 'Document' },
      responseType: 'blob' as 'json',
    });
  }

  getReportDocumentByColumnId(
    endpoint: string,
    employeeNumber: string,
    extension: string,
    language?: string
  ): Observable<any> {
    let url = `${Config.apiRoot.uri}pdf-service/${endpoint}/${employeeNumber}`;

    url = language ? url + `/${language}` : url;

    return this.http
      .get(url, {
        headers: {
          vrmCustom_requestName: 'Report File',
        },
        responseType: 'blob' as 'json',
      })
      .pipe(
        map((response) => {
          console.log('%c Requested Report File - ArrayBuffer', 'color: salmon', response);
          return this.generatedStreamLink(response, extension);
        })
      );
  }

  private generatedStreamLink(docResponse: any, extension: string): string {
    const binaryData = [];
    let streamLink = '';

    const contentType: string = this.matchExtensionToMimetype[extension];
    if (!contentType) {
      this.cService.showToast(':: ' + this.cService.readyTranslations.messagesAndWarnings.fileMayNotWorkCorrectly);
      console.warn('VRM WARNING: This file may not DOWNLOAD or RENDER correctly due to missing ContentType');
    }

    binaryData.push(docResponse);
    streamLink = window.URL.createObjectURL(
      new Blob(binaryData, {
        type: contentType,
      })
    );

    return streamLink;
  }

  // ---- JOINS ----
  getAllTrainingModulesMetaForkJoined(moduleName: string): Observable<any> {
    return forkJoin([this.getTrainingModuleMeta(moduleName), this.getAllTrainingModules(moduleName)]);
  }
}
